"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CLOSE_ENCODED_VAA_COMPUTE_BUDGET = exports.WRITE_ENCODED_VAA_COMPUTE_BUDGET = exports.INIT_ENCODED_VAA_COMPUTE_BUDGET = exports.UPDATE_PRICE_FEED_COMPUTE_BUDGET = exports.POST_UPDATE_COMPUTE_BUDGET = exports.POST_UPDATE_ATOMIC_COMPUTE_BUDGET = exports.VERIFY_ENCODED_VAA_COMPUTE_BUDGET = void 0;
/**
 * A hard-coded budget for the compute units required for the `verifyEncodedVaa` instruction in the Wormhole program.
 */
exports.VERIFY_ENCODED_VAA_COMPUTE_BUDGET = 350000;
/**
 * A hard-coded budget for the compute units required for the `postUpdateAtomic` instruction in the Pyth Solana Receiver program.
 */
exports.POST_UPDATE_ATOMIC_COMPUTE_BUDGET = 170000;
/**
 * A hard-coded budget for the compute units required for the `postUpdate` instruction in the Pyth Solana Receiver program.
 */
exports.POST_UPDATE_COMPUTE_BUDGET = 35000;
/**
 * A hard-coded budget for the compute units required for the `updatePriceFeed` instruction in the Pyth Push Oracle program.
 */
exports.UPDATE_PRICE_FEED_COMPUTE_BUDGET = 55000;
/**
 * A hard-coded budget for the compute units required for the `initEncodedVaa` instruction in the Wormhole program.
 */
exports.INIT_ENCODED_VAA_COMPUTE_BUDGET = 3000;
/**
 * A hard-coded budget for the compute units required for the `writeEncodedVaa` instruction in the Wormhole program.
 */
exports.WRITE_ENCODED_VAA_COMPUTE_BUDGET = 3000;
/**
 * A hard-coded budget for the compute units required for the `closeEncodedVaa` instruction in the Wormhole program.
 */
exports.CLOSE_ENCODED_VAA_COMPUTE_BUDGET = 30000;
